const loadBoardView = {
  title: 'Tablero de Cargas',
  toolbar: {
    addService: 'Agregar Servicio',
    addRoute: 'Agregar Ruta',
    search: {
      label: 'Buscar servicios',
      placeholder: 'Buscar servicios...',
    },
    loadSearch: {
      aria: 'Buscar cargas...',
      placeholder: 'Buscar cargas...',
    },
    selectDate: 'Seleccionar fecha',
    today: 'Hoy',
  },
  content: {
    noLoads: 'No hay cargas disponibles en este momento',
    availableLoads: 'Cargas Disponibles',
    error: 'Error al cargar cargas: {{message}}',
  },
  columns: {
    completed: 'Completado',
    assigned: 'Asignado al Conductor',
    pending: 'Pendiente de Recoleccion',
    inTransit: 'En Transito',
    delayed: 'Retrasado',
    documentation: 'Documentacion Pendiente',
  },
  driverCard: {
    defaultTruck: 'Camión Predeterminado',
    defaultTrailer: 'Remolque Predeterminado',
    changeTruck: 'Cambiar Camión',
    changeTrailer: 'Cambiar Remolque',
    noTruck: 'Sin camión',
    noTrailer: 'Sin remolque',
    active: 'activo',
    done: 'hecho',
    planned: 'planificado',
    draft: 'borrador',
    createTask: 'Crear tarea',
    submitToQueue: 'Enviar a la cola',
    createRoute: 'Crear ruta',
    printTasks: 'Imprimir tareas',
  },
  tabs: {
    unassigned: 'Sin asignar',
    requests: 'Solicitudes',
  },
  pinnedEmpty: 'El portal de proveedores aún no está disponible',
  pendingToolbar: {
    message:
      'Tareas pendientes. Proceda a agregarlas a la cola de conductores.',
    submitAll: 'Enviar todas las tareas',
    submitting: 'Enviando...',
  },
  errors: {
    revertToDraft: 'Error al revertir el servicio a borrador.',
    transitionFailed:
      'Error al transicionar el servicio a Planificado. La asignación fue revertida.',
    rollbackFailed:
      'La asignación fue exitosa pero no se pudo revertir — se requiere resolución manual.',
    assignFailed: 'Error al asignar el servicio al conductor.',
    columnOrderFailed: 'Error al guardar el orden de columnas.',
  },
  emptyState: {
    title: 'No se encontraron cargas',
    description:
      'Intente ajustar su busqueda o filtros para encontrar lo que busca.',
  },
};

const routesView = {
  toolbar: {
    search: 'Buscar rutas...',
    delete: (count: number) =>
      count === 1 ? 'Eliminar' : `Eliminar ${count} rutas`,
  },
  table: {
    aria: 'Lista de Rutas',
    columns: {
      id: 'ID',
      name: 'Nombre',
      routeDate: 'Fecha de Ruta',
      driver: 'Conductor',
      services: 'Servicios',
    },
    actions: {
      edit: 'Editar',
    },
  },
  content: {
    error: (message: string) => `Error al cargar rutas: ${message}`,
    noData: 'No hay rutas disponibles',
  },
  status: {
    Planned: 'Planificada',
    Active: 'Activa',
    Completed: 'Completada',
    Failed: 'Fallida',
    Voided: 'Anulada',
  },
  messages: {
    deleteSuccess: (count: number) =>
      `${count} ruta(s) eliminada(s) exitosamente`,
    error: 'Ocurrio un error al procesar su solicitud',
  },
  form: {
    title: {
      create: 'Nueva Ruta',
      edit: 'Editar Ruta',
      view: 'Ver Ruta',
    },
    fields: {
      facilityGroup: 'Grupo de Instalaciones',
      name: 'Nombre de Ruta',
      driver: 'Asignar Conductor',
      routeDate: 'Fecha de Ruta',
      status: 'Estado',
    },
    placeholders: {
      name: 'Ingrese nombre de ruta',
      driver: 'Seleccionar conductor',
      status: 'Seleccionar estado',
    },
    buttons: {
      cancel: 'Cancelar',
      create: 'Crear Ruta',
      save: 'Guardar Cambios',
      activate: 'Activar Ruta',
      complete: 'Completar Ruta',
      void: 'Anular Ruta',
      fail: 'Marcar como Fallida',
      edit: 'Editar Ruta',
    },
    messages: {
      createSuccess: 'Ruta creada exitosamente',
      updateSuccess: 'Ruta actualizada exitosamente',
      activateSuccess: 'Ruta activada exitosamente',
      completeSuccess: 'Ruta completada exitosamente',
      voidSuccess: 'Ruta anulada exitosamente',
      failSuccess: 'Ruta marcada como fallida',
      error: 'Error al guardar ruta',
      facilityGroupRequired: 'El grupo de instalaciones es requerido',
      transitionSuccess: 'Estado de ruta actualizado exitosamente',
    },
    statuses: {
      Planned: 'Planificada',
      Active: 'Activa',
    },
    tabs: {
      services: 'Servicios',
      tasks: 'Tareas',
      routeMap: 'Mapa de Ruta',
      routeMapWip: 'La vista del mapa de ruta estara disponible proximamente.',
    },
    services: {
      availableServices: 'Servicios Disponibles',
      routeServices: 'Servicios de la Ruta',
      noAvailableServices: 'No hay servicios disponibles',
      noRouteServices: 'No se han agregado servicios a la ruta',
      dragFromLeft: 'Arrastre servicios desde el panel izquierdo',
      viewModeMessage:
        'Los servicios no se pueden modificar en modo de visualizacion',
      noTasks: 'No se han generado tareas para esta ruta',
      position: 'Posición',
    },
  },
};

const servicesView = {
  form: {
    title: {
      create: 'Nuevo Servicio',
      edit: 'Editar Servicio',
      view: 'Ver Servicio',
      service: (num: number | string) =>
        `Servicio #${String(num).padStart(6, '0')}`,
    },
    modes: {
      simple: 'Simple',
      advanced: 'Avanzado',
    },
    sections: {
      taskDetails: 'Detalles de Tarea',
      location: 'Ubicacion',
      actionsAndBins: 'Acciones y Contenedores',
      transportation: 'Transporte',
      otherDetails: 'Otros Detalles',
    },
    fields: {
      type: 'Tipo',
      status: 'Estado',
      rank: 'Rango',
      priority: 'Prioridad',
      location: 'Ubicacion',
      scheduledWindowStart: 'Inicio de Ventana',
      scheduledWindowEnd: 'Fin de Ventana',
      scheduledDate: 'Fecha Programada',
      description: 'Descripcion',
      notes: 'Notas',
      internalNotes: 'Notas Internas',
      externalNotes: 'Notas Externas',
      route: 'Ruta',
      driver: 'Conductor',
      truck: 'Camion',
      trailer: 'Remolque',
      facilityGroup: 'Grupo de Instalaciones',
      facility: 'Instalación',
      destinationFacility: 'Instalación de Destino',
      estimatedArrival: 'Llegada Estimada',
      account: 'Cuenta',
      hauler: 'Transportista',
      newLocation: 'Nueva Ubicacion',
      existingLocation: 'Ubicacion',
      address: {
        saveLocation: 'Guardar Ubicacion',
        type: 'Tipo de Direccion',
        location: 'Ubicacion',
        manualLocation: 'Ubicacion Manual',
        streetAddress: 'Direccion',
        city: 'Ciudad',
        state: 'Estado',
        postalCode: 'Codigo Postal',
        country: 'Pais',
        account: 'Cuenta',
        addressName: 'Nombre de Direccion',
        locationName: 'Nombre de Ubicación',
        types: {
          standard: 'Estandar',
          nonStandard: 'No Estandar',
          poBox: 'Apartado Postal',
        },
      },
      assets: {
        assets: 'Activos',
        assetGroup: (n: number) => `Grupo de Activos ${n}`,
        add: 'Agregar Activo',
        none: 'No se agregaron activos',
        unknown: 'Desconocido',
        selectSpecific: 'Seleccionar activo especifico',
        asset: 'Activo',
        assetType: 'Tipo de Activo',
        quantity: 'Cantidad',
        locationRefs: {
          service_location: 'Ubicación del Servicio',
          facility: 'Instalación',
          destination_facility: 'Instalación de Destino',
        } as Record<string, string>,
      },
    },
    placeholders: {
      facilityGroup: 'Seleccionar un grupo de instalaciones',
      facility: 'Seleccionar una instalación',
      account: 'Seleccionar una cuenta',
      location:
        'Buscar por cuenta / instalacion / nombre de recolector o direccion',
      streetAddress: 'Ingrese direccion',
      city: 'Ingrese ciudad',
      state: 'Ingrese estado',
      postalCode: 'Ingrese codigo postal',
      country: 'Ingrese pais',
      selectAccount: 'Seleccionar una cuenta',
      addressName: 'Ingrese nombre de ubicacion',
      driver: 'Buscar un conductor...',
      truck: 'Buscar un camion...',
      trailer: 'Buscar un remolque...',
      description: 'Ingrese descripcion',
      notes: 'Ingrese notas adicionales',
      hauler: 'Buscar un transportista...',
      route: 'Buscar una ruta...',
      asset: 'Buscar un activo...',
    },
    buttons: {
      cancel: 'Cancelar',
      remove: 'Eliminar',
      create: 'Crear Servicio',
      saveAndAddLocation: 'Guardar y Agregar Ubicacion',
      complete: 'Completar Servicio',
      void: 'Anular Servicio',
      save: 'Guardar Cambios',
      edit: 'Editar Servicio',
      plan: 'Planificar',
      start: 'Iniciar',
      fail: 'Marcar como Fallido',
      confirm: 'Confirmar',
    },
    messages: {
      createSuccess: 'Servicio creado exitosamente',
      updateSuccess: 'Servicio actualizado exitosamente',
      voidSuccess: 'Servicio anulado exitosamente',
      completeSuccess: 'Servicio completado exitosamente',
      error: 'Error al guardar servicio',
      locationSaved: 'Ubicacion guardada exitosamente',
      locationError: 'Error al guardar ubicacion',
      planSuccess: 'Servicio planificado exitosamente',
      startSuccess: 'Servicio iniciado',
      failSuccess: 'Servicio marcado como fallido',
      transitionSuccess: 'Estado del servicio actualizado exitosamente',
    },
    reasonPrompts: {
      voidReason: 'Motivo de anulación',
      failReason: 'Motivo de falla',
      reasonPlaceholder: 'Ingrese motivo...',
      confirm: 'Confirmar',
    },
  },
  types: {
    pickup: 'Recoleccion',
    delivery: 'Entrega',
    maintenance: 'Mantenimiento',
    transfer: 'Transferencia',
  },
  statuses: {
    draft: 'Borrador',
    planned: 'Planificado',
    inProgress: 'En Progreso',
    completed: 'Completado',
    failed: 'Fallido',
    voided: 'Anulado',
  },
  assignmentStatuses: {
    Unassigned: 'Sin Asignar',
    Offered: 'Ofrecido',
    Accepted: 'Aceptado',
    Rejected: 'Rechazado',
    Released: 'Liberado',
  },
  driverProgress: {
    NotStarted: 'No Iniciado',
    EnRoute: 'En Camino',
    OnSite: 'En el Sitio',
    Completed: 'Completado',
    Failed: 'Fallido',
  },
  haulerProgress: {
    NotStarted: 'No Iniciado',
    InProgress: 'En Progreso',
    Completed: 'Completado',
    Failed: 'Fallido',
  },
};

const assetsView = {
  title: 'Activos',
  toolbar: {
    addAsset: 'Nuevo Activo',
    search: {
      label: 'Buscar activos',
      placeholder: 'Buscar activos...',
    },
  },
  content: {
    noAssets: 'No hay activos disponibles',
    availableAssets: 'Activos Disponibles',
    error: (message: string) => `Error al cargar activos: ${message}`,
  },
  filters: {
    status: {
      all: 'Todos los Estados',
      inventory: 'Inventario',
      deployed: 'Desplegado',
      inTransit: 'En Transito',
      outOfOrder: 'Fuera de Servicio',
    },
  },
  form: {
    title: {
      create: 'Nuevo Activo',
      edit: 'Editar Activo',
    },
    fields: {
      id: 'ID',
      identifier: 'Activo #',
      type: 'Tipo de Activo',
      description: 'Descripcion',
      status: 'Estado',
      tareWeight: 'Peso Tara',
    },
    buttons: {
      cancel: 'Cancelar',
      create: 'Crear Activo',
      save: 'Guardar Cambios',
    },
    messages: {
      createSuccess: 'Activo creado exitosamente',
      updateSuccess: 'Activo actualizado exitosamente',
      error: 'Error al guardar activo',
    },
  },
  detail: {
    tabs: {
      details: 'Detalles',
      location: 'Ubicación',
    },
    sections: {
      info: 'Información del Activo',
      associations: 'Asociaciones',
      location: 'Ubicación',
    },
    fields: {
      fillState: 'Estado de Llenado',
      notes: 'Notas',
      account: 'Cuenta',
      facility: 'Instalación',
      currentLocation: 'Ubicación Actual',
      lastLocationTime: 'Última Actualización',
    },
    buttons: {
      edit: 'Editar',
      save: 'Guardar',
      cancel: 'Cancelar',
      delete: 'Eliminar',
      confirmDelete: 'Sí, eliminar este activo',
    },
    messages: {
      updateSuccess: 'Activo actualizado exitosamente',
      deleteSuccess: 'Activo eliminado exitosamente',
      error: 'Error al actualizar activo',
    },
  },
};

const assetTypesView = {
  title: 'Tipos de Activos',
  toolbar: {
    addType: 'Nuevo Tipo de Activo',
    search: {
      label: 'Buscar tipos de activos',
      placeholder: 'Buscar tipos de activos...',
    },
  },
  content: {
    noTypes: 'No hay tipos de activos definidos',
    availableTypes: 'Tipos de Activos Disponibles',
    error: (message: string) => `Error al cargar tipos de activos: ${message}`,
  },
  table: {
    columns: {
      id: 'ID',
      name: 'Nombre',
      description: 'Descripcion',
      capacity: 'Capacidad',
      createdAt: 'Creado',
      updatedAt: 'Actualizado',
    },
  },
  form: {
    title: {
      create: 'Nuevo Tipo de Activo',
      edit: 'Editar Tipo de Activo',
    },
    fields: {
      name: 'Nombre',
      description: 'Descripcion',
      capacity: 'Capacidad',
    },
    buttons: {
      cancel: 'Cancelar',
      create: 'Crear Tipo de Activo',
      save: 'Guardar Cambios',
    },
    messages: {
      createSuccess: 'Tipo de activo creado exitosamente',
      updateNotImplemented: 'Actualizacion aun no implementada',
      error: 'Error al guardar tipo de activo',
    },
  },
};

const transportationTypes = {
  toolbar: {
    create: 'Nuevo Tipo de Transporte',
    search: 'Buscar tipos de transporte...',
    delete: (count: number) =>
      count === 1 ? 'Eliminar' : `Eliminar ${count} tipos`,
  },
  table: {
    aria: 'Lista de Tipos de Transporte',
    columns: {
      id: 'ID',
      name: 'Nombre',
      description: 'Descripcion',
      createdAt: 'Creado',
      updatedAt: 'Actualizado',
    },
  },
  content: {
    error: (message: string) =>
      `Error al cargar tipos de transporte: ${message}`,
  },
  dialog: {
    title: {
      create: 'Nuevo Tipo de Transporte',
      edit: 'Editar Tipo de Transporte',
    },
    fields: {
      name: 'Nombre',
      description: 'Descripcion',
    },
    buttons: {
      cancel: 'Cancelar',
      create: 'Crear Tipo de Transporte',
      save: 'Guardar Cambios',
    },
  },
  messages: {
    createSuccess: 'Tipo de transporte creado exitosamente',
    updateSuccess: 'Tipo de transporte actualizado exitosamente',
    deleteSuccess: (count: number) =>
      `${count} tipo(s) de transporte eliminado(s) exitosamente`,
    error: 'Error al guardar tipo de transporte',
  },
};

const trucksView = {
  title: 'Camiones',
  toolbar: {
    create: 'Nuevo Camion',
    search: 'Buscar camiones...',
    delete: (count: number) =>
      count === 1 ? 'Eliminar' : `Eliminar ${count} camiones`,
  },
  table: {
    aria: 'Lista de Camiones',
    columns: {
      id: 'ID',
      status: 'Estado',
      licensePlate: 'Placa',
      model: 'Modelo',
      transportationType: 'Tipo de Transporte',
      capacity: 'Capacidad',
      location: 'Ubicacion',
    },
  },
  content: {
    error: (message: string) => `Error al cargar camiones: ${message}`,
    noData: 'No hay camiones disponibles',
  },
  status: {
    Available: 'Disponible',
    InUse: 'En Uso',
    Inactive: 'Inactivo',
    OutOfService: 'Fuera de Servicio',
  },
  form: {
    status: 'Estado',
    transportationType: 'Tipo de Transporte',
    licensePlate: 'Placa',
    licensePlateExpiration: 'Vencimiento de Placa',
    model: 'Modelo',
    vin: 'VIN',
    capacity: 'Capacidad',
    country: 'Pais',
    state: 'Estado',
    notes: 'Notas',
    validation: {
      required: 'Este campo es requerido',
      invalidDate: 'Por favor ingrese una fecha valida',
      invalidNumber: 'Por favor ingrese un numero valido',
    },
  },
  dialog: {
    title: {
      create: 'Nuevo Camion',
      edit: 'Editar Camion',
    },
    actions: {
      save: 'Guardar',
      create: 'Crear',
      cancel: 'Cancelar',
    },
  },
  messages: {
    createSuccess: 'Camion creado exitosamente',
    updateSuccess: 'Camion actualizado exitosamente',
    deleteSuccess: (count: number) =>
      `${count} camion(es) eliminado(s) exitosamente`,
    error: 'Ocurrio un error al procesar su solicitud',
  },
  filters: {
    status: {
      all: 'Todos los Estados',
      available: 'Disponible',
      inUse: 'En Uso',
      inactive: 'Inactivo',
    },
  },
  emptyState: {
    title: 'No se encontraron camiones',
    description:
      'Intente ajustar su busqueda o filtros para encontrar lo que busca.',
  },
};

const trailersView = {
  title: 'Remolques',
  toolbar: {
    create: 'Nuevo Remolque',
    search: 'Buscar remolques...',
    delete: (count: number) =>
      count === 1 ? 'Eliminar' : `Eliminar ${count} remolques`,
  },
  table: {
    aria: 'Lista de Remolques',
    columns: {
      id: 'ID',
      status: 'Estado',
      licensePlate: 'Placa',
      transportationType: 'Tipo de Transporte',
      capacity: 'Capacidad',
      location: 'Ubicacion',
    },
  },
  content: {
    error: (message: string) => `Error al cargar remolques: ${message}`,
    noData: 'No hay remolques disponibles',
  },
  status: {
    Available: 'Disponible',
    InUse: 'En Uso',
    Inactive: 'Inactivo',
    OutOfService: 'Fuera de Servicio',
  },
  form: {
    status: 'Estado',
    transportationType: 'Tipo de Transporte',
    licensePlate: 'Placa',
    licensePlateExpiration: 'Vencimiento de Placa',
    vin: 'VIN',
    capacity: 'Capacidad',
    country: 'Pais',
    state: 'Estado',
    notes: 'Notas',
    validation: {
      required: 'Este campo es requerido',
      invalidDate: 'Por favor ingrese una fecha valida',
      invalidNumber: 'Por favor ingrese un numero valido',
    },
  },
  dialog: {
    title: {
      create: 'Nuevo Remolque',
      edit: 'Editar Remolque',
    },
    actions: {
      save: 'Guardar',
      create: 'Crear',
      cancel: 'Cancelar',
    },
  },
  messages: {
    createSuccess: 'Remolque creado exitosamente',
    updateSuccess: 'Remolque actualizado exitosamente',
    deleteSuccess: (count: number) =>
      `${count} remolque(s) eliminado(s) exitosamente`,
    error: 'Ocurrio un error al procesar su solicitud',
  },
  filters: {
    status: {
      all: 'Todos los Estados',
      available: 'Disponible',
      inUse: 'En Uso',
      inactive: 'Inactivo',
    },
  },
  emptyState: {
    title: 'No se encontraron remolques',
    description:
      'Intente ajustar su busqueda o filtros para encontrar lo que busca.',
  },
};

const driversView = {
  title: 'Conductores',
  toolbar: {
    create: 'Nuevo Conductor',
    search: 'Buscar conductores...',
    delete: (count: number) =>
      count === 1 ? 'Eliminar' : `Eliminar ${count} conductores`,
  },
  table: {
    aria: 'Lista de Conductores',
    columns: {
      id: 'ID',
      status: 'Estado',
      address: 'Direccion',
      name: 'Nombre',
      licenseNumber: 'Numero de Licencia',
      licenseExpiration: 'Vencimiento de Licencia',
      phone: 'Telefono',
      email: 'Correo Electronico',
      assignedTruck: 'Camion Asignado',
    },
  },
  content: {
    error: (message: string) => `Error al cargar conductores: ${message}`,
    noData: 'No hay conductores disponibles',
  },
  status: {
    Available: 'Disponible',
    OnDuty: 'En Servicio',
    OffDuty: 'Fuera de Servicio',
    OnBreak: 'En Descanso',
    Inactive: 'Inactivo',
  },
  form: {
    status: 'Estado',
    firstName: 'Nombre',
    lastName: 'Apellido',
    licenseNumber: 'Numero de Licencia',
    licenseExpiration: 'Vencimiento de Licencia',
    phone: 'Telefono',
    email: 'Correo Electronico',
    assignedTruck: 'Camion Asignado',
    notes: 'Notas',
    validation: {
      required: 'Este campo es requerido',
      invalidDate: 'Por favor ingrese una fecha valida',
      invalidEmail: 'Por favor ingrese un correo electronico valido',
      invalidPhone: 'Por favor ingrese un numero de telefono valido',
    },
  },
  dialog: {
    title: {
      create: 'Nuevo Conductor',
      edit: 'Editar Conductor',
    },
    actions: {
      save: 'Guardar',
      create: 'Crear',
      cancel: 'Cancelar',
    },
  },
  messages: {
    createSuccess: 'Conductor creado exitosamente',
    updateSuccess: 'Conductor actualizado exitosamente',
    deleteSuccess: ({ count }: { count: number }) =>
      `${count} conductor(es) eliminado(s) exitosamente`,
    error: 'Ocurrio un error al procesar su solicitud',
  },
  filters: {
    status: {
      all: 'Todos los Estados',
      available: 'Disponible',
      onDuty: 'En Servicio',
      offDuty: 'Fuera de Servicio',
      onBreak: 'En Descanso',
      inactive: 'Inactivo',
    },
  },
  emptyState: {
    title: 'No se encontraron conductores',
    description:
      'Intente ajustar su busqueda o filtros para encontrar lo que busca.',
  },
};

const serviceTypes = {
  predefinedNote:
    'Los tipos de servicio son predefinidos. Puede personalizar el nombre de visualización.',
  toolbar: {
    search: 'Buscar tipos de servicio...',
  },
  table: {
    aria: 'Lista de Tipos de Servicio',
    columns: {
      id: 'ID',
      name: 'Nombre',
      description: 'Descripción',
      status: 'Estado',
      createdAt: 'Creado',
    },
    systemDefault: 'Sistema',
    active: 'Activo',
    inactive: 'Inactivo',
  },
  content: {
    error: (message: string) => `Error al cargar tipos de servicio: ${message}`,
  },
  emptyState: {
    title: 'No se encontraron tipos de servicio',
    description: 'Intente ajustar su búsqueda para encontrar lo que busca.',
  },
  dialog: {
    title: {
      view: 'Ver Tipo de Servicio',
      edit: 'Editar Tipo de Servicio',
    },
    fields: {
      name: 'Nombre',
      description: 'Descripción',
      isActive: 'Activo',
    },
    taskDefinitions: {
      title: 'Definiciones de Tareas',
      empty: 'No hay definiciones de tareas configuradas',
      assetRole: 'Rol del Activo',
      taskType: 'Tipo de Tarea',
      sequence: 'Secuencia',
      locationRef: 'Ubicación',
      locations: {
        A: 'Ubicación A',
        B: 'Ubicación B',
        C: 'Ubicación C',
      },
      overridable: '(puede anular)',
      allowLocationOverride: 'Permitir Anulación de Ubicación',
      taskTypes: {
        Pickup: 'Recolección',
        Delivery: 'Entrega',
        Fill: 'Llenar',
        Empty: 'Vaciar',
        Reposition: 'Reposicionar',
      },
      assetRoles: {
        inbound: 'Entrada',
        outbound: 'Salida',
        none: 'Ninguno',
      },
    },
    buttons: {
      cancel: 'Cancelar',
      save: 'Guardar Cambios',
      close: 'Cerrar',
    },
  },
  messages: {
    updateSuccess: 'Tipo de servicio actualizado exitosamente',
    error: 'Error al guardar tipo de servicio',
  },
};

const detentions = {
  toolbar: {
    search: 'Buscar detenciones...',
    create: 'Nueva Detenci\u00f3n',
  },
  table: {
    aria: 'Lista de Detenciones',
    columns: {
      carrier: 'Transportista',
      location: 'Ubicaci\u00f3n',
      startDate: 'Fecha de Inicio',
      endDate: 'Fecha de Fin',
      freeMinutes: 'Minutos Gratis',
      ratePerMinute: 'Tarifa/Min',
      createdAt: 'Creado',
    },
  },
  content: {
    error: (message: string) => `Error al cargar detenciones: ${message}`,
  },
  emptyState: {
    title: 'No se encontraron detenciones',
    description:
      'Intenta ajustar tu b\u00fasqueda para encontrar lo que buscas.',
  },
  dialog: {
    title: {
      create: 'Nueva Detenci\u00f3n',
      edit: 'Editar Detenci\u00f3n',
      view: 'Ver Detenci\u00f3n',
    },
    fields: {
      carrier: 'Transportista',
      location: 'Ubicaci\u00f3n',
      startDate: 'Fecha de Inicio',
      endDate: 'Fecha de Fin',
      freeMinutes: 'Minutos Gratis',
      ratePerMinute: 'Tarifa Por Minuto',
    },
    buttons: {
      cancel: 'Cancelar',
      create: 'Crear Detenci\u00f3n',
      save: 'Guardar Cambios',
      close: 'Cerrar',
      delete: 'Eliminar',
    },
  },
  messages: {
    createSuccess: 'Detenci\u00f3n creada exitosamente',
    updateSuccess: 'Detenci\u00f3n actualizada exitosamente',
    deleteSuccess: 'Detenci\u00f3n eliminada exitosamente',
    error: 'Error al guardar detenci\u00f3n',
  },
};

const freightLanes = {
  toolbar: {
    search: 'Buscar rutas de flete...',
    create: 'Nueva Ruta de Flete',
  },
  table: {
    aria: 'Lista de Rutas de Flete',
    columns: {
      carrier: 'Transportista',
      transportationMode: 'Modo',
      equipmentType: 'Equipo',
      destination: 'Destino',
      status: 'Estado',
      createdAt: 'Creado',
    },
    active: 'Activo',
    inactive: 'Inactivo',
  },
  content: {
    error: (message: string) => `Error al cargar rutas de flete: ${message}`,
  },
  emptyState: {
    title: 'No se encontraron rutas de flete',
    description: 'Intente ajustar su búsqueda para encontrar lo que busca.',
  },
  dialog: {
    title: {
      create: 'Nueva Ruta de Flete',
      edit: 'Editar Ruta de Flete',
      view: 'Ver Ruta de Flete',
    },
    fields: {
      carrier: 'Transportista',
      transportationMode: 'Modo de Transporte',
      equipmentType: 'Tipo de Equipo',
      commodityCategory: 'Categoría de Mercancía',
      destinationCity: 'Ciudad',
      destinationState: 'Estado',
      destinationZipCode: 'Código Postal',
      destinationCountry: 'País',
      route: 'Ruta',
      active: 'Activo',
      notes: 'Notas',
    },
    sections: {
      destination: 'Área de Destino',
    },
    buttons: {
      cancel: 'Cancelar',
      create: 'Crear Ruta de Flete',
      save: 'Guardar Cambios',
      close: 'Cerrar',
      delete: 'Eliminar',
    },
  },
  messages: {
    createSuccess: 'Ruta de flete creada exitosamente',
    updateSuccess: 'Ruta de flete actualizada exitosamente',
    deleteSuccess: 'Ruta de flete eliminada exitosamente',
    error: 'Error al guardar ruta de flete',
  },
  costs: {
    title: 'Historial de Costos',
    add: 'Agregar Costo',
    empty: 'Sin registros de costos',
    fields: {
      startDate: 'Fecha de Inicio',
      endDate: 'Fecha de Fin',
      rateFormula: 'Fórmula de Tarifa',
      chargebackFormula: 'Fórmula de Contracargo',
      fuelSurchargeFormula: 'Fórmula de Recargo por Combustible',
      fuelSurchargeMode: 'Modo de Recargo por Combustible',
      minimumCharge: 'Cargo Mínimo',
      currency: 'Moneda',
    },
    form: {
      titleCreate: 'Nuevo Registro de Costo',
      titleEdit: 'Editar Registro de Costo',
      cancel: 'Cancelar',
      create: 'Agregar Costo',
      save: 'Guardar Costo',
    },
    messages: {
      createSuccess: 'Registro de costo creado exitosamente',
      updateSuccess: 'Registro de costo actualizado exitosamente',
      deleteSuccess: 'Registro de costo eliminado exitosamente',
      error: 'Error al guardar registro de costo',
    },
  },
};

export const es = {
  loadBoardView,
  routesView,
  servicesView,
  assetsView,
  assetTypesView,
  transportationTypes,
  trucksView,
  trailersView,
  driversView,
  serviceTypes,
  detentions,
  freightLanes,
};
